import React from "react"
import { IntlProvider } from "react-intl"
import API from "../../services/API"

import messages_en from "../../assets/data/locales/en.json"
import messages_pt from "../../assets/data/locales/pt.json"
import messages_es from "../../assets/data/locales/es.json"

const menu_messages = {
  en: messages_en,
  pt: messages_pt,
  es: messages_es
}

const Context = React.createContext()

class IntlProviderWrapper extends React.Component {
  // Carregar idioma do localStorage ou usar padrão
  getInitialLocale = () => {
    if (typeof window !== 'undefined') {
      const savedLocale = localStorage.getItem('iuli_locale');
      return savedLocale || 'pt';
    }
    return 'pt';
  }

  state = {
    locale: this.getInitialLocale(),
    messages: menu_messages[this.getInitialLocale()]
  }

  componentDidMount() {
    // Tentar carregar idioma do backend após montar o componente
    this.loadLanguageFromBackend();
  }

  loadLanguageFromBackend = async () => {
    try {
      // Avoid redirect-on-401 interceptor by using the plain API instance
      const api = API();
      const userResponse = await api.get('auth/user');
      const user = userResponse?.data || userResponse;
      
      if (user?.language?.code) {
        const backendLocale = user.language.code;
        // Atualizar apenas se for diferente do atual
        if (backendLocale !== this.state.locale) {
          this.setState({
            locale: backendLocale,
            messages: menu_messages[backendLocale] || menu_messages['pt']
          });
          // Sincronizar com localStorage
          if (typeof window !== 'undefined') {
            localStorage.setItem('iuli_locale', backendLocale);
          }
        }
      }
    } catch (error) {
      // Silenciosamente falhar se não conseguir carregar do backend
      // Usar o idioma do localStorage como fallback
      console.debug('Não foi possível carregar idioma do backend:', error);
    }
  }

  render() {
    const { children } = this.props
    const { locale, messages } = this.state
    return (
      <Context.Provider
        value={{
          state: this.state,
          switchLanguage: language => {
            // Salvar no localStorage
            if (typeof window !== 'undefined') {
              localStorage.setItem('iuli_locale', language);
            }
            this.setState({
              locale: language,
              messages: menu_messages[language]
            })
          }
        }}
      >
        <IntlProvider
          key={locale}
          locale={locale}
          messages={messages}
          defaultLocale="pt"
        >
          {children}
        </IntlProvider>
      </Context.Provider>
    )
  }
}

export { IntlProviderWrapper, Context as IntlContext }
